
	import {
		addressInfo,
		saveAddress,
		getExpressMap,
		getExpressCompany,
		getMemberSelectAddress
	} from "@/api/member/member"
	import {
		getArea
	} from "@/api/address"

	export default {
		name: "address_edit",
		components: {},
		data() {
			let self = this
			var isMobile = (rule, value, callback) => {
				if (!value) {
					return callback(new Error("手機號不能為空"))
				} else {
					const reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/

					if (reg.test(value)) {
						callback()
					} else {
						callback(new Error("請輸入正確的手機號"))
					}
				}
			}

			var fullAddress = (rule, value, callback) => {
				if (self.formData.province_id) {
					if (self.formData.city_id) {
						if (self.formData.district_id) {
							return callback()
						} else {
							return callback(new Error("請選擇區/縣"))
						}
					} else {
						return callback(new Error("請選擇市"))
					}
				} else {
					return callback(new Error("請選擇省"))
				}
			}

			return {
				timer: null,
				companyList: [],
				formData: {
					id: 0,
					name: "",
					mobile: "",
					telephone: "",
					province_id: "",
					city_id: "",
					district_id: "",
					community_id: "",
					address: "",
					full_address: "",
					company_id: '',
					latitude: 0,
					longitude: 0,
					is_default: 1,
					CVSStoreID: '',
					CVSStoreName: '',
					CVSAddress: '',
					CVSTelephone: ''
				},
				addressValue: "",
				flag: false, //防重復標識
				defaultRegions: [],
				rules: {
					name: [{
						required: true,
						message: "請輸入收貨人姓名",
						trigger: "blur"
					}],
					mobile: [{
						required: true,
						validator: isMobile,
						trigger: "blur"
					}],
					CVSStoreName: [{
						required: true,
						message: "請選擇收貨地址",
						trigger: "blur"
					}],
					company_id: [{
						required: true,
						message: "請選擇寄送方式",
						trigger: "blur"
					}],
					full_address: [{
						required: true,
						validator: fullAddress,
						trigger: "blur"
					}]
				},
				province: [],
				city: [],
				district: [],
				pickerValueArray: [],
				multiIndex: [0, 0, 0],
				isInitMultiArray: false,
				// 是否加載完默認地區
				isLoadDefaultAreas: false,
				loading: true,
				yes: true
			}
		},
		created() {
			this.formData.id = this.$route.query.id
			this.getAddressDetail()
			this.getDefaultAreas(0, {
				level: 0
			})
			this.getCompanyList()

			// window.addEventListener('message', function(e) { // 監聽 message 事件
			// 	console.log("從" + e.origin + "收到消息： " + e.data)
			// });
		},
		mounted() {
			let self = this;
			setTimeout(function() {
				self.yes = false
			}, 300)
		},
		watch: {
			defaultRegions: {
				handler(arr, oldArr = []) {
					// 避免傳的是字面量的時候重復觸發
					if (arr.length !== 3 || arr.join("") === oldArr.join("")) return
					this.handleDefaultRegions()
				},
				immediate: true
			}
		},
		computed: {
			pickedArr() {
				// 進行初始化
				if (this.isInitMultiArray) {
					return [this.pickerValueArray[0], this.pickerValueArray[1], this.pickerValueArray[2]]
				}
				return [this.pickerValueArray[0], this.city, this.district]
			}
		},
		methods: {
			checkAddressStatus() {
				this.timer = setInterval(() => {
					getMemberSelectAddress({})
						.then(res => {
							const {
								code,
								message,
								data
							} = res;
							if (Object.keys(data).length > 0) {
								this.formData.CVSAddress = data.CVSAddress || ''
								this.formData.CVSStoreID = data.CVSStoreID || ''
								this.formData.CVSStoreName = data.CVSStoreName || ''
								this.formData.CVSTelephone = data.CVSTelephone || ''
							}
						})
						.catch(err => {
							clearInterval(this.timer);
						});
				}, 2500);
			},
			//選擇門店
			chooseStoreAddress() {

				if (this.formData.company_id.length == 0) {
					this.$message.error('請先選擇寄送方式')
					return
				}
				let that = this
				getExpressMap({
					company_id: this.formData.company_id
				}).then(res => {
					let data = res.data
					window.open(data.url, '_blank')
					that.checkAddressStatus()
				})
			},
			//獲取寄送方式
			getCompanyList() {
				getExpressCompany({

				}).then(res => {
					this.companyList = res.data
				}).catch(err => {})
			},
			/** 
			 * 改變省
			 */
			changeProvice(id) {
				this.getAreas(id, data => (this.city = data))
				let obj = {}
				obj = this.province.find(item => {
					//這裏的province就是上面遍歷的數據源
					return item.id === id //篩選出匹配數據
				})
				this.formData.city_id = ""
				this.formData.district_id = ""
				this.formData.full_address = obj.name // 設置選中的地址
			},
			/**
			 * 改變市
			 */
			changeCity(id) {
				this.getAreas(id, data => (this.district = data))
				let obj = {}
				obj = this.city.find(item => {
					//這裏的province就是上面遍歷的數據源
					return item.id === id //篩選出匹配數據
				})
				this.formData.district_id = ""
				this.formData.full_address = this.formData.full_address + "-" + obj.name
			},
			/**
			 * 改變區
			 */
			changeDistrict(id) {
				let obj = {}
				obj = this.district.find(item => {
					//這裏的province就是上面遍歷的數據源
					return item.id === id //篩選出匹配數據
				})
				this.formData.full_address = this.formData.full_address + "-" + obj.name
			},
			/**
			 * 獲取地址信息
			 */
			getAddressDetail() {
				addressInfo({
						id: this.formData.id
					})
					.then(res => {
						let data = res.data
						if (data != null) {
							this.formData.name = data.name
							this.formData.mobile = data.mobile
							this.formData.telephone = data.telephone
							this.formData.address = data.address
							this.formData.full_address = data.full_address
							this.formData.latitude = data.latitude
							this.formData.longitude = data.longitude
							this.formData.is_default = data.is_default
							this.formData.province_id = data.province_id
							this.formData.city_id = data.city_id
							this.formData.district_id = data.district_id
							this.formData.company_id = data.company_id
							this.formData.CVSAddress = data.CVSAddress
							this.formData.CVSStoreID = data.CVSStoreID
							this.formData.CVSStoreName = data.CVSStoreName
							this.formData.CVSTelephone = data.CVSTelephone
							this.defaultRegions = [data.province_id, data.city_id, data.district_id]
						}
					})
					.catch(err => {})
			},
			// 異步獲取地區
			getAreas(pid, callback) {
				getArea({
						pid: pid
					})
					.then(res => {
						if (res.code == 0) {
							var data = []
							res.data.forEach((item, index) => {
								data.push(item)
							})
							if (callback) callback(data)
						}
					})
					.catch(err => {})
			},

			/**
			 * 獲取省市區列表
			 */
			getDefaultAreas(pid, obj) {
				getArea({
						pid: pid
					})
					.then(res => {
						if (res.code == 0) {
							var data = []
							var selected = undefined
							res.data.forEach((item, index) => {
								if (obj != undefined) {
									if (obj.level == 0 && obj.province_id != undefined) {
										selected = obj.province_id
									} else if (obj.level == 1 && obj.city_id != undefined) {
										selected = obj.city_id
									} else if (obj.level == 2 && obj.district_id != undefined) {
										selected = obj.district_id
									}
								}

								if (selected == undefined && index == 0) {
									selected = item.id
								}
								data.push(item)
							})

							this.pickerValueArray[obj.level] = data
							if (obj.level + 1 < 3) {
								obj.level++
								this.getDefaultAreas(selected, obj)
							} else {
								this.isInitMultiArray = true
								this.isLoadDefaultAreas = true
							}

							this.province = this.pickerValueArray[0]
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},

			/**
			 * 渲染默認值
			 */
			handleDefaultRegions() {
				var time = setInterval(() => {
					if (!this.isLoadDefaultAreas) return
					this.isInitMultiArray = false

					for (let i = 0; i < this.defaultRegions.length; i++) {
						for (let j = 0; j < this.pickerValueArray[i].length; j++) {
							this.province = this.pickerValueArray[0]

							// 匹配省
							if (this.defaultRegions[i] == this.pickerValueArray[i][j].id) {
								// 設置選中省
								this.$set(this.multiIndex, i, j)
								// 查詢市
								this.getAreas(this.pickerValueArray[i][j].id, data => {
									this.city = data

									for (let k = 0; k < this.city.length; k++) {
										if (this.defaultRegions[1] == this.city[k].id) {
											// 設置選中市
											this.$set(this.multiIndex, 1, k)

											// 查詢區縣
											this.getAreas(this.city[k].id, data => {
												this.district = data

												// 設置選中區縣
												for (let u = 0; u < this.district.length; u++) {
													if (this.defaultRegions[2] == this.district[u]
														.id) {
														this.$set(this.multiIndex, 2, u)
														this.handleValueChange({
															detail: {
																value: [j, k, u]
															}
														})
														break
													}
												}
											})

											break
										}
									}
								})
							}
						}
					}
					if (this.isLoadDefaultAreas) clearInterval(time)
				}, 100)
			},
			handleValueChange(e) {
				// 結構賦值
				let [index0, index1, index2] = e.detail.value
				let [arr0, arr1, arr2] = this.pickedArr
				let address = [arr0[index0], arr1[index1], arr2[index2]]

				this.formData.full_address = ""
				for (let i = 0; i < address.length; i++) {
					if (this.formData.full_address) {
						this.formData.full_address = this.formData.full_address + "-" + address[i].name
					} else {
						this.formData.full_address = this.formData.full_address + address[i].name
					}
				}
			},

			/**
			 * 保存地址
			 */
			saveAddress(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						var data = {
							name: this.formData.name,
							mobile: this.formData.mobile,
							telephone: this.formData.telephone,
							province_id: this.formData.province_id,
							city_id: this.formData.city_id,
							district_id: this.formData.district_id,
							community_id: "",
							address: this.formData.address,
							full_address: this.formData.full_address,
							latitude: this.formData.latitude,
							longitude: this.formData.longitude,
							is_default: this.formData.is_default,
							CVSAddress: this.formData.CVSAddress,
							CVSStoreID: this.formData.CVSStoreID,
							CVSStoreName: this.formData.CVSStoreName,
							CVSTelephone: this.formData.CVSTelephone,
							company_id: this.formData.company_id
						}

						data.url = "add"
						if (this.formData.id) {
							data.url = "edit"
							data.id = this.formData.id
						}
						if (this.flag) return
						this.flag = true

						saveAddress(data)
							.then(res => {
								if (res.code == 0) {
									clearInterval(this.timer);

									this.$router.push({
										path: "/member/delivery_address"
									})
								} else {
									this.flag = false
									this.$message({
										message: res.message,
										type: "warning"
									})
								}
							})
							.catch(err => {
								clearInterval(this.timer);

								this.flag = false
								this.$message.error(err.message)
							})
					} else {
						return false
					}
				})
			}
		}
	}
